import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "react-feather";
import { AssetsList } from "../../elements/assetsList";

import Button from "../../elements/button";

import * as Styles from "./styles";

const BgTitle = () => {
  const { pathname } = useLocation();

  const isHome = pathname === "/";
  const isAbout = pathname === "/about";
  const isProjects = pathname === "/projects";
  const isClients = pathname === "/clients";
  const isContact = pathname === "/contactus";

  if (
    pathname.includes("/projects/") &&
    pathname.length > "/projects/".length
  ) {
    return null;
  }

  const { home, about, projects, clients, contact } = AssetsList.titleBg;

  const currentBg = isHome
    ? home
    : isAbout
    ? about
    : isProjects
    ? projects
    : isClients
    ? clients
    : isContact
    ? contact
    : home;

  const eyebrow = isAbout
    ? "About us"
    : isProjects
    ? "Our projects"
    : isClients
    ? "Our clients"
    : isContact
    ? "Contact us"
    : "Retrofitting & Structural Strengthening";

  return (
    <Styles.Container img={currentBg} tall={isHome}>
      <Styles.Overlay />
      <Styles.Wrapper className="container">
        <Styles.Holder>
          <Styles.Eyebrow>{eyebrow}</Styles.Eyebrow>
          <Styles.Title>
            We Provide Best Retrofitting Structural Strengthening Services
          </Styles.Title>
          {!isContact ? (
            <Styles.Actions>
              <Link to="/contactus">
                <Button>Contact us</Button>
              </Link>
              {isHome ? (
                <Link to="/projects">
                  <Styles.GhostLink>
                    View our projects
                    <ArrowRight aria-hidden="true" />
                  </Styles.GhostLink>
                </Link>
              ) : null}
            </Styles.Actions>
          ) : null}
        </Styles.Holder>
      </Styles.Wrapper>
    </Styles.Container>
  );
};

export default BgTitle;
